import { Checkbox, useTheme } from "@mui/material";
import { SyntheticEvent } from "react";
import { Link } from "react-router-dom";
import DefaultImage from "../../../assets/SuntecNewLogo.png";

interface PropTypes {
  tittle?: any;
  value?: string | boolean;
  checked?: boolean;
  onChange?: () => void;
  disabled?: boolean;
  HeaderType?: any;
}
const GetTableInputs = (props: any): JSX.Element => {
  const { HeaderType, ...items } = props;
  const getKey = () => {
    const rowKey = Object.keys(HeaderType)?.filter(
      (item) => item !== "header" && item !== "key"
    )[0];
    switch (rowKey) {
      case "isCheckbox":
        return <GetCheckBox {...items} />;
      default:
        return <GetLinkElement {...props} />;
    }
  };

  return getKey();
};

const GetCheckBox = (props: any) => {
  const theme = useTheme();
  const { style, metaData, ...items } = props;
  return (
    <Checkbox
      sx={{
        minWidth: "5rem",
        maxWidth: "5rem",
        height:'2rem',
        "&.Mui-checked": {
          color: `${theme.color?.secondary} `,
        },
      }}
      {...items}
    />
  );
};

const GetLinkElement = (props: any) => {
  const { tittle, HeaderType, metaData, ...items } = props;
  const { key, style, to } = items;
  const isImage =
    metaData && metaData[HeaderType.key] && metaData[HeaderType.key].isImage;
  return (
    <Link key={key} style={style} to={to}>
      {isImage ? <GetImage title={tittle}/> : tittle}{" "}
    </Link>
  );
};

const GetImage=(props:any)=>{
  const {title}= props
  const handleError = (event: SyntheticEvent<HTMLImageElement, Event>) => {
    event.currentTarget.src = DefaultImage;
  };
 return (
   <img
     src={title}
     onError={handleError}
     style={{
       height: "3rem",
       minWidth: "7rem",
       maxWidth:'12rem',
       objectFit: "fill",
     }}
   />
 );
}
export default GetTableInputs;
